import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  PageContent,
  Container,
  Row,
  Col,
  Field,
  Heading,
  Button,
} from 'components';
import { Margin } from 'styled-components-spacing';
import clearErrors from 'helpers/clearErrors';
import FileInput from '../../../components/FileInput/FileInput';
import { iconList } from 'assets';
import { File, RemoveIcon, ToUploadList } from '../ChangeRequest.styled';



const AddChangeRequest = ({
  state,
  dispatch,
  updateFieldCreator,
  errors,
  createChangeRequest,
  removeError,
  type,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleChangeNative = (name, errorName) => (e) => {
    dispatch(updateFieldCreator({ name, value: e.target.value }));
    if (errors[errorName]) removeError(clearErrors(errors, errorName));
  };

  const handleChangeFileNative = (name) => (e) => {
    const newFiles = Array.from(e.target.files || []);
    const currentFiles = state.files || [];
    const updatedFiles = [...currentFiles, ...newFiles];
    
    dispatch(
      updateFieldCreator({
        name,
        dataType: 'file',
        value: updatedFiles,
      }),
    );
    if (errors.files) removeError(clearErrors(errors, 'files'));
    // Reset the input to allow selecting the same file again
    e.target.value = '';
  };

  const handleRemoveFile = (index) => {
    const updatedFiles = state.files.filter((_, i) => i !== index);
    dispatch(
      updateFieldCreator({
        name: 'files',
        dataType: 'file',
        value: updatedFiles,
      }),
    );
  };

  const submit = () => {
    const formData = new FormData();
    formData.append('description', state.description || '');
    
    state.files.forEach((file) => {
      formData.append('files[]', file);
    });

    createChangeRequest(formData, history);
  };

  return (
    <PageContent>
      <Container>
        <form>
          <Margin bottom="24">
            <Heading size="h5">
              {t('page.user.cis.changeRequests.addChangeRequest')}
            </Heading>
          </Margin>
          <Row>
            <Col size={{ xl: 1 }}>
              <Margin bottom="20">
                <Field
                  id="description"
                  label={t('page.user.cis.changeRequests.description')}
                  error={errors.description}
                >
                  <textarea
                    id="description"
                    rows="5"
                    placeholder={t('page.user.cis.changeRequests.descriptionPlaceholder')}
                    value={state.description}
                    onChange={handleChangeNative('description', 'description')}
                  />
                </Field>
              </Margin>
            </Col>
          </Row>
          <Row>
            <Col size={{ xl: 1 / 3 }}>
              <Margin bottom="20">
                <Field
                  id="files"
                  label={t('page.user.cis.changeRequests.files')}
                  error={errors.files}
                >
                  <FileInput
                    multiple
                    placeholder={t('page.user.cis.changeRequests.addFiles')}
                    onChange={(e) => handleChangeFileNative('files')(e)}
                    clear={() => {}}
                    fileName=""
                  />
                </Field>
                {state.files && state.files.length > 0 && (
                  <ToUploadList>
                    {state.files.map((file, index) => (
                      <File key={`${file.name}-${index}`}>
                        <RemoveIcon
                          src={iconList.close}
                          title="Remove file"
                          onClick={() => handleRemoveFile(index)}
                        />
                        {file.name}
                      </File>
                    ))}
                  </ToUploadList>
                )}
              </Margin>
            </Col>
          </Row>
          <Row>
            <Col size={{ xl: 1 / 4 }}>
                <Button onClick={submit} type="button">
                  {t('global.submit')}
                </Button>
            </Col>
            <Col size={{ xl: 1 / 4 }}>                
              <Button secondary onClick={() => history.goBack()} type="button" style={{ marginLeft: '10px' }}>
                  {t('global.cancel')}
              </Button></Col>
          </Row>
        </form>
      </Container>
    </PageContent>
  );
};

AddChangeRequest.propTypes = {
  state: PropTypes.shape({
    id: PropTypes.number,
    description: PropTypes.string,
    files: PropTypes.array,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  updateFieldCreator: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    description: PropTypes.string,
    files: PropTypes.string,
  }),
  createChangeRequest: PropTypes.func.isRequired,
  removeError: PropTypes.func.isRequired,
  type: PropTypes.string,
};

AddChangeRequest.defaultProps = {
  errors: {},
  type: 'ma',
};

export default AddChangeRequest;
